<div class="label-container">
    <div class="d-flex justify-content-center align-items-center">
        <label class="text-color-primary text-center">{{control.title}}</label>
    </div>
    <div *ngIf="showSettings">
        <mat-form-field appearance="outline" class="time-input compact me-2" subscriptSizing="dynamic">
            <mat-label>{{control.inputName}}</mat-label>
            <input matInput type="number" [(ngModel)]="control.value" />
        </mat-form-field>
        <button mat-button class="p-0 m-0" style="min-width:0;padding:0 4px;height:22px;line-height:22px;" (click)="toggleSettings()">
            <span class="material-symbols-outlined" style="font-size:15px;line-height:1;display:block;">settings</span>
        </button>
    </div>
    <div *ngIf="!showSettings">
        <label class="text-color-primary text-center me-2">{{control.value}}</label>
        <button mat-button class="p-0 m-0" style="min-width:0;padding:0 4px;height:22px;line-height:22px;" (click)="toggleSettings()">
            <span class="material-symbols-outlined" style="font-size:15px;line-height:1;display:block;">settings</span>
        </button>
    </div>
    
</div>
<div class="slider-wrapper">
    <mat-slider class="w-100 me-2" [max]="control.max" [min]="control.min" [step]="1" [discrete]="true">
        <input matSliderThumb [(ngModel)]="control.value">
    </mat-slider>
</div>
<div class="w-100 d-flex align-items-center justify-content-between" *ngIf="showSettings">
    <mat-form-field appearance="outline" class="time-input compact ms-3" subscriptSizing="dynamic">
        <mat-label>min</mat-label>
        <input matInput type="number" [(ngModel)]="control.min" />
    </mat-form-field>

    <mat-form-field appearance="outline" class="time-input compact" subscriptSizing="dynamic">
        <mat-label>max</mat-label>
        <input matInput type="number" [(ngModel)]="control.max" />
    </mat-form-field>
</div>
